import { Avatar, HIDE_IN_STUDIO } from '@ftrprf/tailwind-components';

export function UserInfo({ user }) {
  return (
    <div className="flex items-center px-4">
      <div className="flex-shrink-0">
        {user?.avatar !== HIDE_IN_STUDIO && (
          <Avatar avatar={user?.avatar} className="mr-1 w-6 h-6" />
        )}
      </div>
      <div className="flex-grow">
        <div className="text-base font-medium text-gray-800">
          {user?.firstname} {user?.lastname}
        </div>
        <div className="text-sm font-medium text-gray-500">{user?.email}</div>
      </div>
    </div>
  );
}
